// extracted by mini-css-extract-plugin
export default {"deleteAccount":"UiYe","container":"_8o0u","form":"C+QH"};